/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-redeclare */
import { useTheme } from '@emotion/react';
import { yupResolver } from '@hookform/resolvers/yup';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
  Avatar,
  Box,
  Button,
  Collapse,
  Divider,
  IconButton,
  InputAdornment,
  styled,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { cyan } from '@mui/material/colors';
import LabelledTextField from 'components/Common/LabelledTextField';
import PhoneNumberField from 'components/Common/PhoneNumberField';
import CommonDialog from 'components/CommonDialog';
import CheckCircleBroken from 'components/Icons/CheckCircleBroken';
import Enums from 'constants/Enums';
import { MyContext } from 'Context';
import translatedFormValidationSchemas from 'FormValidations/translatedFormValidationSchemas';
import { getLocalStorageItem, setLocalStorageItem } from 'hooks';
import MakeIndependent from 'pages/Patients/MakeIndependent';
import { useAuthMe, useResendCodeQuery } from 'queries/AuthQueries';
import {
  useDeletePictureApiQuery,
  useUpdateInfoApiQuery,
  useUploadProfileImageApiQuery,
} from 'queries/MyInformation';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import HandleErrorResponse from 'utils/HandleErrorResponse';
import * as yup from 'yup';

import DeactivateAccountDialog from './DeactivateAccountDialog';
import DeleteAccountDialog from './DeleteAccountDialog';
import VerifyMobilePopup from './VerifyMobilePopup';

const AnimatedIconButton = styled(IconButton)(({ theme }) => ({
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.short,
  }),
}));

const AccountInfo = () => {
  const { data: profile } = useAuthMe();
  const { t } = useTranslation('account');
  const { t: translate, i18n } = useTranslation('validationErrorMessages');
  const theme: any = useTheme();
  const isSmScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMdScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  const [open, setOpen] = useState<boolean>(false);
  // const [image, setImage] = useState<string>('');

  const rolesLayout = getLocalStorageItem('roles');
  const [firstName, setFirstName] = useState<string>();
  const [lastName, setLastName] = useState<string>();
  const [userName, setUserName] = useState<string>();
  const [userEmail, setUserEmail] = useState<string>();
  const [phoneNumber, setPhoneNumber] = useState<any>(
    // eslint-disable-next-line no-unsafe-optional-chaining
    rolesLayout?.country ? rolesLayout?.country + rolesLayout?.phone : ''
  );
  const [buttonEnable, setButtonEnable] = useState<boolean>(false);
  const [verificationType, setVerificationType] = useState<string>('');
  const { mutate: uploadProfileApi } = useUploadProfileImageApiQuery();
  const { mutate: deleteProfileApi } = useDeletePictureApiQuery();
  const { mutate: updateInfoApi } = useUpdateInfoApiQuery();
  const { mutate: resendCodeApi } = useResendCodeQuery();
  const [template, setTemplate] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [phoneErrorMessage, setPhoneErrorMessage] = useState<string>('');
  const [valueChange, setValueChange] = useState<boolean>(false);
  const [openDeactivateDialog, setOpenDeactivateDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openCollapseSetting, setOpenCollapseSetting] = useState(false);
  const { isDependent, dependentData } = useContext(MyContext);
  // console.log(dependentData?.isdependent);

  const handleClose = () => {
    setOpen(false);
  };
  const { first_name, last_name, username } = useMemo(() => {
    return translatedFormValidationSchemas(translate, i18n.language);
  }, [translate, i18n.language]);

  const accountSchema = yup.object().shape({
    first_name,
    last_name,
    username,
  });
  const {
    register,
    handleSubmit,
    setError,
    reset,
    setValue,
    formState: { errors },
    clearErrors,
  } = useForm({
    resolver: yupResolver(accountSchema),
    defaultValues: {
      first_name: firstName || rolesLayout?.firstName,
      last_name: lastName || rolesLayout?.lastName,
      username: userName || rolesLayout?.username,
    },
  });
  const handleChangeValue = (
    field: any,
    value: any,
    shouldValidate = false
  ) => {
    setValue(field, value, {
      shouldValidate: field in errors || shouldValidate,
    });
  };
  useEffect(() => {
    clearErrors();
  }, [translate, i18n.language]);

  useEffect(() => {
    if (isDependent) {
      const data = JSON.parse(localStorage.getItem('selectedDependent') || '');

      setFirstName(data?.firstName);
      setLastName(data?.lastName);
      setUserName(data?.username);
      setUserEmail(data?.email);

      // Set the default values for the form fields
      reset({
        first_name: data.firstName,
        last_name: data.lastName,
        username: data.username,
      });
    } else if (profile?.data) {
      setFirstName(profile.data.firstName);
      setLastName(profile.data.lastName);
      setUserName(profile.data.username);
      setUserEmail(profile.data.email);

      // Set the default values for the form fields
      reset({
        first_name: profile.data.firstName,
        last_name: profile.data.lastName,
        username: profile.data.username,
      });
    }
  }, [profile?.data, reset, isDependent, dependentData]);
  const navigate = useNavigate();
  const underSm = useMediaQuery(theme.breakpoints.down('sm'));
  const [name, setName] = useState<string>('');
  const [phoneValid, setPhoneValid] = useState<boolean>(false);
  const [emailVerified, setEmailVerified] = useState<boolean>(false);
  const [phoneVerified, setPhoneVerified] = useState<boolean>(false);
  const [emailVerifiedAt, setEmailVerifiedAt] = useState<any>(null);
  const [phoneVerifiedAt, setPhoneVerifiedAt] = useState<any>(null);
  const [showIndependentForm, setShowIndependentForm] =
    useState<boolean>(false);
  const handleOpen = (data: string, value: any) => {
    setVerificationType(data);
    const sendOnValue =
      data === 'Phone' && value && !value.startsWith('+') ? `+${value}` : value;
    const payload: any = {
      ...(data === 'Email' && { sendOn: value }),
      ...(data === 'Phone' && { sendOn: sendOnValue }),
      eventCode:
        data === 'Email'
          ? Enums.EventType.EMAIL_VERIFY
          : Enums.EventType.PHONE_VERIFY,
    };
    resendCodeApi(payload, {
      onSuccess: (res: any) => {
        setOpen(true);
        setTemplate(res?.data?.message.split(','));
        setPhoneErrorMessage('');
        setErrorMessage('');
      },
      onError: (err: any) => {
        if (data === 'Email') {
          setErrorMessage(err?.fieldErrors[0]?.message);
        } else {
          setPhoneErrorMessage(err?.fieldErrors[0]?.message);
        }
      },
    });
  };

  const { picture } = getLocalStorageItem('roles');
  const image = getLocalStorageItem('profileImage');
  const handleUploadProfilePhoto = (e: any) => {
    const file = e?.target?.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        if (event.target && typeof event.target.result === 'string') {
          const img = new Image();
          img.src = event.target.result;
          img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            if (ctx) {
              const isLandscape = img.width > img.height;
              canvas.width = isLandscape ? img.height : img.width;
              canvas.height = isLandscape ? img.width : img.height;

              if (isLandscape) {
                ctx.rotate((90 * Math.PI) / 180);
                ctx.translate(0, -canvas.width);
              }

              ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

              // Convert the canvas to a blob and append it to the FormData
              canvas.toBlob((blob) => {
                if (blob) {
                  const data = new FormData();
                  data.append('file', blob);
                  const payload: any = {
                    file: blob,
                  };

                  // Call the old upload function (uploadProfileApi) here
                  uploadProfileApi(payload, {
                    onSuccess: (res: any) => {
                      setLocalStorageItem('profileImage', res?.picture);
                    },
                  });
                } else {
                  // Handle the case when blob is null
                }
              });
            } else {
              // Handle the case when ctx is null
            }
          };
        } else {
          // Handle the case when event.target or result is null or not a string
        }
      };
      reader.readAsDataURL(file);
    } else {
      // Handle the case when file is null
    }
    // Reset the input value to ensure onChange triggers next time
    e.target.value = '';
  };

  const handleDeleteImage = () => {
    deleteProfileApi();
    // window.location.reload();
  };
  const handleSaveInfo = () => {
    setFirstName(rolesLayout?.firstName);
    setLastName(rolesLayout?.lastName);
    setUserName(rolesLayout?.username);

    reset({
      first_name: rolesLayout?.firstName,
      last_name: rolesLayout?.lastName,
      username: rolesLayout?.username,
    });
  };
  const handlePhoneNumber = (phoneStr: any) => {
    // handleChangeValue('phone', phoneStr);
    const phoneNumber = phoneStr?.phone?.slice(1);
    setPhoneNumber(phoneStr?.phone);
    // setPhoneValid(true);
  };

  useEffect(() => {
    const { emailVerifiedAt, phoneVerifiedAt } = getLocalStorageItem('roles');
    if (emailVerifiedAt || phoneVerifiedAt) {
      setEmailVerifiedAt(emailVerifiedAt);
      setPhoneVerifiedAt(phoneVerifiedAt);
    }
  }, [emailVerifiedAt, phoneVerifiedAt]);

  const submitAuthForm = (data: any) => {
    const updatePayload: any = {
      firstName: data?.first_name ? data?.first_name : rolesLayout?.firstName,
      lastName: data?.last_name ? data?.last_name : rolesLayout?.lastName,
      username: data?.username ? data?.username : rolesLayout?.username,
      employeeCode: null,
    };
    updateInfoApi(updatePayload, {
      onSuccess: () => {
        setFirstName(data?.first_name);
        setLastName(data?.last_name);
        setUserName(data?.username);
      },
      onError: (err: any) => {
        HandleErrorResponse(err, setError);
      },
    });
  };
  const handleAuthErrors = () => {};

  useEffect(() => {
    const roles = getLocalStorageItem('roles');
    roles?.roles?.forEach((item: any) => {
      if (item?.includes('practice_admin')) {
        setName('Admin');
      } else {
        setName('User');
      }
    });
  }, []);

  const handleEmailVerified = (val: boolean) => {
    setEmailVerified(val);
  };

  const handlePhoneVerified = (value: boolean) => {
    setPhoneVerified(value);
  };

  const HandleNavigation = () => {
    navigate('/bio-metric/info');
  };

  const handleOpenDeactivateDialog = () => setOpenDeactivateDialog(true);
  const handleCloseDeactivateDialog = () => setOpenDeactivateDialog(false);
  const handleOpenDeleteDialog = () => setOpenDeleteDialog(true);
  const handleCloseDeleteDialog = () => setOpenDeleteDialog(false);

  const handleToggle = () => {
    setOpenCollapseSetting(!openCollapseSetting);
  };

  const handleShowMakeIndpendentForm = () => {
    setShowIndependentForm(!showIndependentForm);
  };

  return (
    <>
      <div className=" relative p-4 lg:px-16 lg:py-8">
        {dependentData?.isdependent && (
          <Button
            variant="contained"
            className="absolute right-0 top-0 text-xs md:text-sm"
            onClick={handleShowMakeIndpendentForm}
          >
            {t('makeindependent')}
          </Button>
        )}

        <CommonDialog
          fullWidth={true}
          maxWidth={'sm'}
          open={showIndependentForm}
          onClose={handleShowMakeIndpendentForm}
        >
          <MakeIndependent
            setOpen={setShowIndependentForm}
            userdata={dependentData}
          />
        </CommonDialog>

        <form onSubmit={handleSubmit(submitAuthForm, handleAuthErrors)}>
          <div className="border-b border-gray-300 pb-4">
            <div
              className={` relative  pb-4${
                isMdScreen ? 'border-b' : 'border-b-2'
              } border-gray-300`}
            >
              <Typography
                fontSize={18}
                fontWeight={600}
                color="secondary.100"
                className="relative inline-block "
              >
                {name === 'Admin' ? t('profileInformation') : 'Account Info'}
                <Typography
                  className={`absolute left-[110%] top-0 z-10 rounded-lg  p-2 py-1 font-semibold text-white ${
                    isDependent ? 'bg-primary-700' : 'bg-primary-600'
                  }`}
                  fontSize={isSmScreen ? 9 : 12}
                >
                  {isDependent ? 'Dependent' : 'Independent'}
                </Typography>
              </Typography>
              <Typography variant="subtitle2" fontWeight={400} color="font.900">
                {t('profileInfoHeading')}
              </Typography>
            </div>

            <div className="mt-4 flex flex-col gap-4 border-b border-gray-300 pb-4 lg:mt-8 lg:flex-row lg:gap-4">
              <div className="w-full lg:w-[280px]">
                <Typography
                  variant="subtitle2"
                  fontWeight={500}
                  color="font.main"
                >
                  {t('yourPhoto')}
                </Typography>
                <Typography
                  variant="subtitle2"
                  fontWeight={400}
                  color="font.900"
                >
                  {t('yourPhotoLabelText')}
                </Typography>
              </div>
              <div className="flex items-center gap-4">
                <Avatar
                  alt="Remy Sharp"
                  src={profile?.data?.picture || picture}
                  sx={{ width: 56, height: 56 }}
                />
                <div className="flex items-center gap-4 sm:flex-col sm:items-start lg:flex-row lg:items-center">
                  {profile?.data?.picture || picture ? (
                    <Typography
                      variant="subtitle2"
                      fontWeight={600}
                      color="font.900"
                      className="cursor-pointer"
                      onClick={handleDeleteImage}
                    >
                      {t('DeleteButtonText', { defaultValue: 'Delete' })}
                    </Typography>
                  ) : (
                    <Typography
                      variant="subtitle2"
                      fontWeight={600}
                      color="secondary.400"
                    >
                      {t('DeleteButtonText', { defaultValue: 'Delete' })}
                    </Typography>
                  )}
                  <label htmlFor="upload-photo" className="cursor-pointer">
                    <input
                      style={{ display: 'none' }}
                      id="upload-photo"
                      name="upload-photo"
                      type="file"
                      accept="image/*"
                      onChange={handleUploadProfilePhoto}
                    />
                    <Typography
                      variant="subtitle2"
                      fontWeight={600}
                      color={cyan[600]}
                    >
                      {t('UpdateButtonText', { defaultValue: 'Update' })}
                    </Typography>
                  </label>
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-4 pb-4 lg:flex-row lg:gap-8">
              <div className="w-full lg:w-[280px]">
                <Typography
                  variant="subtitle2"
                  fontWeight={500}
                  color="font.main"
                  marginTop="10px"
                >
                  Name
                </Typography>
              </div>
              <div className="flex w-full flex-col gap-4 lg:w-[731.5px] lg:flex-row">
                <LabelledTextField
                  className="mt-1 w-full lg:w-[50%]"
                  variant="outlined"
                  placeholder={`${t('firstNamePlaceholder')}`}
                  {...register('first_name')}
                  onChange={(e: any) => {
                    handleChangeValue('first_name', e.target.value, true);
                    setFirstName(e.target.value);
                    setButtonEnable(true);
                  }}
                  error={Boolean(errors.first_name)}
                  helperText={
                    errors && errors.first_name && errors.first_name.message
                  }
                  // value={firstName}
                />
                <LabelledTextField
                  className="mt-1 w-full lg:w-[50%]"
                  variant="outlined"
                  placeholder={`${t('lastNamePlaceholder')}`}
                  {...register('last_name')}
                  onChange={(e1: any) => {
                    handleChangeValue('last_name', e1.target.value, true);
                    setLastName(e1.target.value);
                    setButtonEnable(true);
                  }}
                  error={Boolean(errors.last_name)}
                  helperText={
                    errors && errors.last_name && errors.last_name.message
                  }
                  // value={lastName}
                />
              </div>
            </div>
            <div className="flex flex-col gap-4 pb-4 lg:flex-row lg:gap-8">
              <div className="w-full lg:w-[280px]">
                <Typography
                  variant="subtitle2"
                  fontWeight={500}
                  color="font.main"
                  marginTop="10px"
                >
                  {t('userName')}
                </Typography>
              </div>
              <div className="w-full lg:w-[731.5px]">
                <LabelledTextField
                  className="mt-1 w-full"
                  variant="outlined"
                  placeholder={`${t('userNamePlaceholder')}`}
                  {...register('username')}
                  onChange={(event: any) => {
                    handleChangeValue('username', event.target.value, true);
                    setUserName(event.target.value);
                    setButtonEnable(true);
                  }}
                  error={Boolean(errors.username)}
                  helperText={
                    errors && errors.username && errors.username.message
                  }
                  //  value={userName}
                />
              </div>
            </div>
            <div className="mt-4 flex flex-col-reverse items-end pb-4 lg:mt-8 lg:flex-row lg:items-center lg:justify-end lg:pb-8">
              <div className="flex gap-3">
                <Button
                  className={`w-full lg:w-auto ${
                    !buttonEnable ? 'cursor-not-allowed !bg-[#90cdf4]' : ''
                  }`}
                  variant="outlined"
                  color="font"
                  disabled={!buttonEnable}
                  onClick={handleSaveInfo}
                >
                  {t('cancelButtonText')}
                </Button>
                <Button
                  className={`w-full bg-[#11AC9E] hover:bg-[#90BEE6] lg:w-auto ${
                    !buttonEnable ? 'cursor-not-allowed !bg-[#90cdf4]' : ''
                  }`}
                  type="submit"
                  disabled={!buttonEnable}
                >
                  {t('saveButtonText')}
                </Button>
              </div>
            </div>
            <div className="flex flex-col gap-4 pb-4 lg:flex-row lg:gap-8">
              <div className="w-[280px]">
                <Typography
                  variant="subtitle2"
                  fontWeight={500}
                  color="font.main"
                  marginTop="10px"
                >
                  {t('emailAddress')}
                </Typography>
              </div>
              <div>
                <div className="flex w-[100%] items-center gap-4 lg:w-[731.5px]">
                  <LabelledTextField
                    className="mt-1 w-full lg:w-[70%]"
                    variant="outlined"
                    placeholder={`${t('emailPlaceholder')}`}
                    value={userEmail}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {emailVerifiedAt !== null ? (
                            <CheckCircleBroken />
                          ) : null}
                        </InputAdornment>
                      ),
                    }}
                    onChange={(event1: any) => {
                      setErrorMessage('');
                      setUserEmail(event1.target.value);
                    }}
                  />
                  <div className="shrink-0">
                    {emailVerifiedAt === null && !emailVerified ? (
                      <Typography
                        variant="subtitle2"
                        fontWeight={600}
                        color={
                          userEmail !== '' ? 'primary.600' : 'secondary.300'
                        }
                        className={
                          userEmail !== '' ? 'cursor-pointer' : 'cursor-default'
                        }
                        onClick={() =>
                          userEmail !== '' ? handleOpen('Email', userEmail) : ''
                        }
                      >
                        {t('verifyEmail')}
                      </Typography>
                    ) : (
                      <Typography
                        variant="subtitle2"
                        fontWeight={600}
                        color="secondary.300"
                      >
                        {t('verified')}
                      </Typography>
                    )}
                  </div>
                </div>
                {errorMessage && (
                  <span className="m-0 p-0">
                    <p className="text-md font-normal text-error-500">
                      {errorMessage}
                    </p>
                  </span>
                )}
              </div>
            </div>
            <div className="flex flex-col gap-4 pb-4 lg:flex-row lg:gap-8">
              <div className="w-[280px]">
                <Typography
                  variant="subtitle2"
                  fontWeight={500}
                  color="font.main"
                  marginTop="8px"
                >
                  {t('mobileNumber')}
                </Typography>
              </div>
              <div>
                <div className="flex w-[100%] items-center gap-4 lg:w-[731.5px]">
                  <div className="w-full lg:w-[70%]">
                    <PhoneNumberField
                      labelText=""
                      placeholder="(555) 000-000"
                      value={`+${profile?.data.country} ${profile?.data.phone}`}
                      onChange={handlePhoneNumber}
                    />
                  </div>
                  <div className="shrink-0">
                    {phoneVerifiedAt === null && !phoneVerified ? (
                      <Typography
                        variant="subtitle2"
                        fontWeight={600}
                        color={!phoneValid ? 'primary.600' : 'secondary.300'}
                        className={
                          !phoneValid && phoneNumber
                            ? 'cursor-pointer'
                            : 'cursor-default'
                        }
                        onClick={() =>
                          !phoneValid && phoneNumber
                            ? handleOpen('Phone', phoneNumber)
                            : ''
                        }
                      >
                        {t('verifyMobile')}
                      </Typography>
                    ) : (
                      <Typography
                        variant="subtitle2"
                        fontWeight={600}
                        color="secondary.300"
                      >
                        {t('verified')}
                      </Typography>
                    )}
                  </div>
                </div>
                {phoneErrorMessage && (
                  <span className="m-0 p-0">
                    <p className="text-md font-normal text-error-500">
                      {phoneErrorMessage}
                    </p>
                  </span>
                )}
              </div>
            </div>
          </div>
        </form>
        <CommonDialog maxWidth="md" open={open} onClose={handleClose}>
          <VerifyMobilePopup
            setOpen={setOpen}
            verificationType={verificationType}
            template={template}
            handleEmailVerified={handleEmailVerified}
            handlePhoneVerified={handlePhoneVerified}
            updatedEmail={userEmail}
            updatedPhone={phoneNumber}
          />
        </CommonDialog>
      </div>
      {!isDependent && <Divider />}
      <div className="px-4">
        {isSmScreen && (
          <div className="mb-10">
            <div className="flex items-center justify-between py-2">
              <div>
                <Typography
                  fontSize={20}
                  fontWeight={600}
                  color="secondary.100"
                >
                  {t('biometric')}
                </Typography>
              </div>
              <Button className="px-2 py-1 text-sm" onClick={HandleNavigation}>
                {t('enabled')}
              </Button>
            </div>
            <Typography variant="subtitle2" fontWeight={400} color="font.900">
              {t('bioMetricLock')}
            </Typography>
          </div>
        )}
      </div>
      <div className={`${underSm ? 'mb-[50px]' : 'my-4'}`}>
        {' '}
        {!isDependent && (
          <div>
            <Box display="flex" alignItems="center" mb={2} gap="8px">
              <Typography fontSize={18} fontWeight={600}>
                Account Setting
              </Typography>
              <AnimatedIconButton
                onClick={handleToggle}
                style={{
                  transform: openCollapseSetting
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                }}
              >
                <KeyboardArrowDownIcon />
              </AnimatedIconButton>
            </Box>
            <Collapse in={openCollapseSetting} timeout="auto" unmountOnExit>
              <div className={`${underSm ? 'mb-[50px]' : ''}`}>
                {profile?.data?.roles?.includes('patient') ? (
                  <>
                    {' '}
                    <Box
                      display="flex"
                      flexDirection={{ xs: 'column', sm: 'row' }}
                      alignItems="center"
                      justifyContent="space-between"
                      mb={2}
                    >
                      <Box
                        mb={{ xs: 2, sm: 0 }}
                        textAlign={{ xs: 'center', sm: 'left' }}
                      >
                        <Typography
                          fontSize={18}
                          fontWeight={600}
                          color="secondary.100"
                        >
                          {t('deactivateAccount')}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          {t('deactivateSummary')}
                        </Typography>
                      </Box>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={handleOpenDeactivateDialog}
                        className="mx-2 min-w-[100px] py-1 text-xs"
                      >
                        {t('Deactivate')}
                      </Button>
                    </Box>
                    <Divider sx={{ mb: 2 }} />
                    <Box
                      display="flex"
                      flexDirection={{ xs: 'column', sm: 'row' }}
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Box
                        mb={{ xs: 2, sm: 0 }}
                        textAlign={{ xs: 'center', sm: 'left' }}
                      >
                        <Typography
                          fontSize={18}
                          fontWeight={600}
                          color="secondary.100"
                        >
                          {t('deleteAccount')}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          {t('deleteSummary')}
                        </Typography>
                      </Box>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={handleOpenDeleteDialog}
                        className="mx-2 min-w-[100px] py-1 text-xs"
                      >
                        {t('Delete')}
                      </Button>
                    </Box>
                  </>
                ) : (
                  <Box
                    display="flex"
                    flexDirection={{ xs: 'column', sm: 'row' }}
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                  >
                    <Box
                      mb={{ xs: 2, sm: 0 }}
                      textAlign={{ xs: 'center', sm: 'left' }}
                    >
                      <Typography
                        fontSize={18}
                        fontWeight={600}
                        color="secondary.100"
                      >
                        {t('deactivateAccount')}{' '}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {t('deactivateSummary')}
                      </Typography>
                    </Box>
                    <Button
                      variant="contained"
                      color="error"
                      onClick={handleOpenDeactivateDialog}
                      className="mx-2 min-w-[100px] py-1 text-xs"
                    >
                      {t('Deactivate')}
                    </Button>
                  </Box>
                )}
              </div>
            </Collapse>
          </div>
        )}
      </div>

      <>
        <DeactivateAccountDialog
          open={openDeactivateDialog}
          onClose={handleCloseDeactivateDialog}
        />
        <DeleteAccountDialog
          open={openDeleteDialog}
          onClose={handleCloseDeleteDialog}
        />
      </>
    </>
  );
};
export default AccountInfo;
